// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"534":"52e299fe","787":"f1e7b2ff"}[chunkId] + ".chunk.js";
};